(function ($) {
  var firstSlide, lastSlide, activeClass = "active",
    cards = $(".leadership-grid .cards-wrapper .card-item"),
    cardOverlay = $(".leadership-grid .card-overlay"),
    pre = $(".leadership-grid .card-overlay .arrow-wrap .pre"),
    next = $(".leadership-grid .card-overlay .arrow-wrap .next"),
    description = $(".leadership-grid .card-overlay .inner-wrap .description .wrapper");
  var number = 500;
  cards.each(function () {
    // $(this).find("h4").append("-" + number);
    var name = $(this).find("h4").text();
    name = name.replace(/\s/g, '-');
    name = name.toLowerCase();
    $(this).attr("id", number).attr("data-name", name);
    number++;
  });
  lastSlide = parseInt($(".leadership-grid .cards-wrapper .card-item:last-child").attr("id"));
  firstSlide = parseInt($(".leadership-grid .cards-wrapper .card-item:first-child").attr("id"));
  cards.on("click", function () {
    var id = $(this).attr("id");
    var name = $(this).find("h4").text();
    name = name.replace(/\s/g, "-").toLowerCase();
    cards.removeClass(activeClass);
    description.removeClass(activeClass).attr("data-id", "");
    $(this).addClass(activeClass);
    cardOverlay.addClass(activeClass);
    var contentHtml = $(this).html();
    description.html(contentHtml).attr("data-id", id);
    var currentId = parseInt(description.attr("data-id"));
    next.css("display", "block");
    pre.css("display", "block");


    if (currentId === firstSlide) {
      pre.css("display", "none");
    } else if (currentId === lastSlide) {
      next.css("display", "none");
    }
    window.location = "#" + name;
    $("body").css("overflow", "hidden");
    // height();
  });
  pre.on("click", function () {
    next.css("display", "block");
    var currentId = description.attr("data-id");
    currentId--;
    var contentHtml = $(".leadership-grid .cards-wrapper .card-item#" + currentId).html();
    description.html(contentHtml).attr("data-id", currentId);
    if (currentId === firstSlide) {
      $(this).css("display", "none");
    }
    $(".leadership-grid .card-overlay.active .description #loader").show();
    $(".leadership-grid .card-overlay.active .description .content").css("opacity", "0");
    $(".leadership-grid .card-overlay.active .description .img-wrap img").on("load", function () {
      $(".leadership-grid .card-overlay.active .description #loader").hide();
      $(".leadership-grid .card-overlay.active .description .content").css("opacity", "1");
    });
    var name = $(".leadership-grid .cards-wrapper .card-item#" + currentId).attr("data-name");
    window.location = "#" + name;
  });
  next.on("click", function () {
    pre.css("display", "block");
    var currentId = description.attr("data-id");
    currentId++;
    var contentHtml = $(".leadership-grid .cards-wrapper .card-item#" + currentId).html();
    description.html(contentHtml).attr("data-id", currentId);
    if (currentId === lastSlide) {
      $(this).css("display", "none");
    }

    $(".leadership-grid .card-overlay.active .description #loader").show();
    $(".leadership-grid .card-overlay.active .description .content").css("opacity", "0");
    $(".leadership-grid .card-overlay.active .description .img-wrap img").on("load", function () {
      $(".leadership-grid .card-overlay.active .description #loader").hide();
      $(".leadership-grid .card-overlay.active .description .content").css("opacity", "1");
    });
    var name = $(".leadership-grid .cards-wrapper .card-item#" + currentId).attr("data-name");
    window.location = "#" + name;
  });
  $(document).on("click", function (e) {
    if ($(e.target).hasClass("close-btn") || $(e.target).hasClass("inner-wrap")) {
      cardOverlay.removeClass(activeClass);
      cards.removeClass(activeClass);
      description.removeClass(activeClass).attr("data-id", "");
      // window.location.hash = "";
      window.history.replaceState({}, document.title, ".");
      $("body").css("overflow", "");
    }
  });
  $(document).on('keydown', function (event) {
    if (event.key == "Escape" && cardOverlay.hasClass(activeClass)) {
      cardOverlay.removeClass(activeClass);
      cards.removeClass(activeClass);
      description.removeClass(activeClass).attr("data-id", "");
      window.location.hash = "";
    }
  });
  if (window.location.hash) {
    var pageURL = $(location).attr("href");
    var myString = pageURL.substr(pageURL.indexOf("#") + 1);
    var idOnPage = false, name;
    cards.each(function () {
      name = $(this).find("h4").text();
      name = name.replace(/\s/g, '-');
      name = name.toLowerCase();
      if (name === myString) {
        idOnPage = true;
        return false;
      }
    });
    if (idOnPage) {
      cards.removeClass(activeClass);
      description.removeClass(activeClass).attr("data-id", "");
      $(".leadership-grid .cards-wrapper .card-item[data-name=" + myString + "]").addClass(activeClass);
      cardOverlay.addClass(activeClass);
      var id = $(".leadership-grid .cards-wrapper .card-item[data-name=" + myString + "]").attr("id");
      var contentHtml = $(".leadership-grid .cards-wrapper .card-item[data-name=" + myString + "]").html();
      description.html(contentHtml).attr("data-id", id);
      var currentId = parseInt(description.attr("data-id"));
      if (currentId === firstSlide) {
        next.css("display", "block");
        pre.css("display", "none");
      } else if (currentId === lastSlide) {
        pre.css("display", "block");
        next.css("display", "none");
      }
    }
  }

  let winHeight = $(window).height();
  let activeCards = $(".leadership-grid .card-overlay.active");
  if (winHeight < 700) {
    $(activeCards).addClass("collapse");
  } else {
    $(".leadership-grid .card-overlay.active").removeClass("collapse");
  }

  $.fn.equalHeights = function () {
    var max_height = 0;
    $(this).each(function () {
      max_height = Math.max($(this).height(), max_height);
    });
    $(this).each(function () {
      $(this).height(max_height);
    });
  };

  function height() {
    let contentHeight = $(window).height();
    description.parent().parent().css("height", contentHeight);
  }
})(jQuery);